import React from 'react';
import CgInfoHint from 'modules/Common/ui/CgInfoHint';
import { labelClass } from 'modules/Common/form/v2/primitives/inputClasses';

// Field label with an info icon that explains regulatory jargon on hover —
// mirrors the FormField popoverTitle/popoverContent pattern from Form v2.
// `triggerTestId` is optional and additive: the icon's accessible name repeats
// the field label, so callers that need to assert on the hover-reveal content
// in a test can pass one instead of reaching for container/node access
// (disallowed by this repo's testing-library lint).
export default function InfoLabel({ htmlFor, help, helpTitle, children, triggerTestId }) {
  return (
    <span className="flex items-center gap-1.5 mb-1">
      <label
        htmlFor={htmlFor}
        className={`${labelClass} !mb-0`}
      >
        {children}
      </label>
      {help ? (
        <CgInfoHint
          title={helpTitle}
          subject={typeof children === 'string' ? children : undefined}
          position="top"
          testId={triggerTestId}
        >
          {help}
        </CgInfoHint>
      ) : null}
    </span>
  );
}
